var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.innerAppid,"size":"small","filterable":"","clearable":""},on:{"change":_vm.selectAccount}},_vm._l((_vm.wxAccountList),function(item){return _c('el-option',{key:item.appid,attrs:{"label":`${item.name}（${_vm.$config.account_types[item.type]}）`,"value":item.appid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }